<template>
    <h1 class="text-red"> Developer only access </h1>
</template>

<script>
export default {
    
}
</script>